import {showNotification} from 'platform/components';
import {LightboxProps, useLightbox, useLightboxActionsFactory} from 'platform/lightbox';

import {useState} from 'react';

import {isNotNil} from 'ramda';

import {useLazyGetSaleVehicleWatermarkPreviewQuery} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {prepareWatermarkImage} from '../utils/prepareWatermarkImage';

export function useVehicleAlbumWatermarkPreview() {
  const [getWatermarkPreview, {isFetching, isLoading}] = useLazyGetSaleVehicleWatermarkPreviewQuery(
    {}
  );

  const [lightboxControls, {onOpen}] = useLightbox('watermarkPreview');
  const lightboxActionsFactory = useLightboxActionsFactory();

  const [previewImage, setPreviewImage] = useState<string>();

  const openWatermarkPreview = (saleVehiclePhotoId: string) => {
    getWatermarkPreview({saleVehiclePhotoId})
      .unwrap()
      .then((response) => {
        if (isNotNil(response.content)) {
          setPreviewImage(prepareWatermarkImage(response.content));
          onOpen(0);
        }
      })
      .catch(() => {
        showNotification.error(i18n.t('general.labels.somethingWentWrong'));
      });
  };

  const getLightboxProps = (): Omit<LightboxProps, 'data-testid'> => ({
    controls: lightboxControls,
    images: lightboxActionsFactory.addFullActions([
      {
        id: 'watermarkPreview',
        url: previewImage?.toString() ?? '',
      },
    ]),
  });

  return {
    isLoading: isFetching || isLoading,
    getLightboxProps,
    openWatermarkPreview,
  };
}
